import { render, staticRenderFns } from "./Refund.vue?vue&type=template&id=15b387d0&scoped=true&"
import script from "./Refund.vue?vue&type=script&lang=js&"
export * from "./Refund.vue?vue&type=script&lang=js&"
import style0 from "./Refund.vue?vue&type=style&index=0&id=15b387d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b387d0",
  null
  
)

export default component.exports